import { atom } from "recoil";
export const valueUpdateFlag = atom({
    key: "valueUpdateFlag", // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});
